import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaPlusCircle, FaTrash, FaCog, FaEdit, FaEye} from "react-icons/fa";
import { Dropdown } from 'react-bootstrap';

class ListVpsUsingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            description: '',
            isChangeDescription: false,
        }
    }


    loadStatus = () => {
        if ( this.props.service.status_vps === 'on' ) {
            return (
                <span className="text-success">
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'off' ) {
            return (
                <span className="text-danger">
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'admin_off' ) {
            return (
                <span className="text-danger">
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'progressing' || this.props.service.status_vps === 'waiting' ) {
            return (
                <span className="text-info">
                    Đang tạo
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'rebuild' ) {
            return (
                <span className="text-info">
                    Đang cài đặt lại
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'reset_password' ) {
            return (
                <span className="text-info">
                    Đang đặt lại mật khẩu
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'change_ip' ) {
            return (
                <span className="text-info">
                    Đang đổi IP
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'expire' ) {
            return (
                <span className="text-danger">
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'cancel' ) {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'delete' ) {
            return (
                <span className="text-danger">
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'change_user' ) {
            return (
                <span className="text-danger">
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className="text-danger">
                    Chưa tạo
                </span>
            )
        }
    }

    checkedService = (event) => {
        if ( event.nativeEvent.shiftKey ) {
            let value = event.target.checked;
            this.props.checkedServiceShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedService( this.props.actionKey );
        }
    }

    changeAutoRenewOn = () => {
        // console.log(this.props.actionKey)
        this.props.changeAutoRenew( this.props.actionKey, 'on' )
    }

    changeAutoRenewOff = () => {
        // console.log(this.props.actionKey)
        this.props.changeAutoRenew( this.props.actionKey, 'off' )
    }

    testThoi = () => {

    }

    changeText = (event) => {
        this.setState({
            description: event.target.value
        })
    }

    submitChangeDescription = () => {
        this.setState({
            isChangeDescription: !this.state.isChangeDescription
        })
        this.props.submitChangeDescription( this.props.actionKey, this.state.description );
    }

    loadDescription = () => {
        if ( this.state.isChangeDescription ) {
            return (
                <>
                    <div className="form-group form-descripton">
                        <textarea rows="5" cols="12" maxLength="40" className="form-control" name="description" onChange={ this.changeText } />
                        <button type="button" name="button" className="close btn-close"
                                onClick={ () => this.changeDescription() }
                        >
                            <span>×</span>
                        </button>
                    </div>
                    <div className="text-right mt-2">
                        <button type="button" name="button" className="btn mr-1 btn-primary"
                                onClick={ () => this.submitChangeDescription() }
                        >
                            Thay đổi
                        </button>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    { this.props.service.description }
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Ghi chú
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <span className="btn-edit text-muted ml-2" onClick={ () => this.changeDescription() }>
                            <FaEdit />
                        </span>
                    </OverlayTrigger>
                </>
            )
        }
    }

    changeDescription = () => {
        this.setState({
            isChangeDescription: !this.state.isChangeDescription
        })
    }

    render() {
        return (
            <>
                {
                    this.props.service.error === 0 ? (
                        <tr>
                            <td>
                                <input type="checkbox" value="1" checked={this.props.service.checked}  onChange={ this.checkedService } />
                            </td>
                            <td>
                                <Link to={'/dich-vu-vps/' + this.props.service.id + '/chi-tiet-dich-vu-vps.html'}>{this.props.service.ip}</Link>
                            </td>
                            <td className="container-passwd">
                                <span className="pass_vps mr-2">
                                    {
                                        this.props.service.isShowPassword ? (
                                            this.props.service.password
                                        ) : (
                                            <>✱✱✱✱✱</>
                                        )
                                    }
                                </span>
                                <button
                                    className="btn btn-sm p-0 m-0 btn-toggle-passwd-vps"
                                    onClick={ () => this.props.tooglePassword(this.props.actionKey) }
                                >
                                    <FaEye />
                                </button>
                            </td>
                            <td>
                                { this.props.service.text_config }
                                {
                                    this.props.service.isChangeRemote && this.props.service.port_remote !== 3389 ? (
                                        <span className="ml-1">
                                            - Port Remote { this.props.service.port_remote }
                                        </span>
                                    ) : (
                                        <></>
                                    )
                                }
                            </td>
                            <td>
                                { this.props.service.text_create_date }
                            </td>
                            <td>
                                {
                                    this.props.service.isExpire || this.props.service.expired ? (
                                        <>
                                            <span className="text-danger">{ this.props.service.text_next_due_date } </span>
                                            -
                                            <span className="text-danger"> { this.props.service.text_day }</span>
                                        </>
                                    ) : (
                                        <>
                                            { this.props.service.text_next_due_date } - { this.props.service.text_day }
                                        </>
                                    )
                                }
                            </td>
                            <td>
                                { this.props.service.text_total_time }
                            </td>
                            <td>
                                { this.props.service.text_billing_cycle }
                            </td>
                            <td>
                                { this.props.service.text_amount }
                            </td>
                            <td>
                                {
                                    this.props.service.autorefund ? (
                                        <div className="form-group input-custom-switch">
                                            <OverlayTrigger
                                                delay={{ hide: 450, show: 300 }}
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        Tắt tự động gia hạn
                                                    </Tooltip>
                                                )}
                                                placement="top"
                                            >
                                                <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                    <input type="checkbox" className="custom-control-input btnHiddenState" id="customSwitch3"
                                                           checked={ this.props.service.autorefund }
                                                           defaultValue={ this.props.service.autorefund }
                                                           onChange={ this.testThoi }
                                                    />
                                                    <label className="custom-control-label" htmlFor="customSwitch3"
                                                           onClick={ this.changeAutoRenewOff } />
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    ) : (
                                        <div className="form-group input-custom-switch">
                                            <OverlayTrigger
                                                delay={{ hide: 450, show: 300 }}
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        Bật tự động gia hạn
                                                    </Tooltip>
                                                )}
                                                placement="top"
                                            >
                                                <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                    <input type="checkbox" className="custom-control-input btnHiddenState" id="customSwitch3"
                                                           checked={ this.props.service.autorefund }
                                                           defaultValue={ this.props.service.autorefund }
                                                           onChange={ this.testThoi }
                                                    />
                                                    <label className="custom-control-label" htmlFor="customSwitch3"
                                                           onClick={ this.changeAutoRenewOn }/>
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    )
                                }
                            </td>
                            <td>
                                { this.loadDescription() }
                            </td>
                            <td>
                                { this.loadStatus() }
                            </td>
                            <td>
                                {
                                    this.props.service.status !== 'Pending' ? (
                                        <>
                                            <OverlayTrigger
                                                delay={{ hide: 450, show: 300 }}
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        Gia hạn VPS
                                                    </Tooltip>
                                                )}
                                                placement="top"
                                            >
                                                <button type="button" className="btn btn-warning btn-sm mr-1 mb-1 text-light" onClick={ () => this.props.showModal( this.props.actionKey, 'expire' ) }>
                                                    <FaPlusCircle />
                                                </button>
                                            </OverlayTrigger>
                                            {
                                                this.props.service.status_vps === 'off' || this.props.service.status_vps === 'on' ? (
                                                    <>
                                                        <OverlayTrigger
                                                            delay={{ hide: 450, show: 300 }}
                                                            overlay={(props) => (
                                                                <Tooltip {...props}>
                                                                    Hành động
                                                                </Tooltip>
                                                            )}
                                                            placement="top"
                                                        >
                                                            <Dropdown className="btn mr-1 mb-1 p-0">
                                                                <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn-sm">
                                                                    <FaCog />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item>
                                                                        <Link class="text-dark" to={"/dat-hang/vps/" + this.props.service.id + "/nang-cap-dich-vu.html"}>Nâng cấp dịch vụ</Link>
                                                                    </Dropdown.Item>
                                                                    {
                                                                        this.props.service.status_vps === 'off' ? (
                                                                            <>
                                                                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'on' ) }>Bật</Dropdown.Item>
                                                                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'restart' ) }>Khởi động lại</Dropdown.Item>
                                                                            </>
                                                                        ) : (
                                                                            <></>
                                                                        )
                                                                    }
                                                                    {
                                                                        this.props.service.status_vps === 'on' ? (
                                                                            <>
                                                                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'off' ) }>Tắt</Dropdown.Item>
                                                                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'restart' ) }>Khởi động lại</Dropdown.Item>
                                                                                <Dropdown.Item>
                                                                                    <Link class="text-dark" to={"/dich-vu-vps/" + this.props.service.id + "/console-vps.html"}>Truy cập Console</Link>
                                                                                </Dropdown.Item>
                                                                                {
                                                                                    this.props.service.isChangeRemote ? (
                                                                                        <>
                                                                                            <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'change_password' ) }>Đổi mật khẩu</Dropdown.Item>
                                                                                            <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'change_port_remote' ) }>Đổi Port Remote</Dropdown.Item>
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                            </>
                                                                        ) : (
                                                                            <></>
                                                                        )
                                                                    }
                                                                    <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'rebuild' ) }>Cài đặt lại</Dropdown.Item>
                                                                    <Dropdown.Item>
                                                                        <Link class="text-dark" to={"/dich-vu-vps/chuyen-khach-hang.html?listVpsId=" + this.props.service.id}>Chuyển khách hàng</Link>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </OverlayTrigger>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </>
                                    ) : (
                                        <></>
                                    )
                                }
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Hủy VPS
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button type="button" className="btn btn-danger btn-sm mr-1 mb-1" onClick={ () => this.props.showModal( this.props.actionKey, 'delete' ) }>
                                        <FaTrash />
                                    </button>
                                </OverlayTrigger>
                            </td>
                        </tr>
                    ) : (
                        <tr>
                            <td colSpan={15} className="text-danger text-center">
                                { this.props.service.message }
                            </td>
                        </tr>
                    )
                }
            </>
        );
    }

}

export default ListVpsUsingComponent;